import { matchPath } from "react-router-dom";

/**
 * Known route patterns, mirrored 1:1 against src/routes/{PublicRoutes,StudentRoutes,AdminRoutes}.tsx
 * (and the same list server-side in Global.Infrastructure/VictoriaMetrics/UserBehaviorEventDefinitions.cs).
 * Keep both lists in sync manually when routes change - this is the source of truth for the "route"
 * label on PageView events, so it must never be a raw pathname (which contains real GUIDs).
 */
const KNOWN_ROUTE_PATTERNS: string[] = [
  // Public
  "/home",
  "/login",
  "/signup",
  "/confirm-email",
  "/forgot-password",
  "/reset-password",
  "/logout",
  // Student
  "/student",
  "/student/dashboard",
  "/student/profile",
  "/student/settings",
  "/student/exercises",
  "/student/exercises/:moduleId",
  "/student/voucher",
  "/student/packages",
  "/student/packages/:packageId",
  "/student/modules",
  "/student/modules/:packageId",
  "/student/modules/:moduleId/completion",
  "/student/modules/:moduleId/test",
  "/student/modules/:moduleId/test/result",
  "/student/knowledge-cloud",
  "/student/cart",
  "/student/checkout/:packageId",
  "/student/checkout/success",
  "/student/level-test",
  "/student/level-test/welcome",
  "/student/level-test/test",
  "/student/level-test/result",
  "/student/subscriptions",
  // Admin
  "/admin/dashboard",
  "/admin/packages",
  "/admin/packages/:packageId",
  "/admin/packages/:packageId/modules/:moduleId",
  "/admin/modules",
  "/admin/modules/:moduleId",
  "/admin/educational",
  "/admin/educational/level-tests-management",
  "/admin/educational/level-tests-management/:id",
  "/admin/educational/module-tests",
  "/admin/educational/module-tests/:moduleId",
  "/admin/educational/vocabulary-management",
  "/admin/educational/vocabulary-management/:groupId",
  "/admin/access",
  "/admin/access/students",
  "/admin/access/students/:studentId",
  "/admin/access/students/:studentId/packages/:packageId",
  "/admin/access/students/:studentId/packages/:packageId/modules/:moduleId/module-test",
  "/admin/access/students/:studentId/level-test",
  "/admin/access/teachers",
  "/admin/access/teachers/:teacherId",
  "/admin/access/users",
  "/admin/access/users/:userId",
  "/admin/promotions",
  "/admin/reports",
  "/admin/reports/accesses-by-day",
  "/admin/reports/registrations-by-day",
  "/admin/vouchers",
  "/admin/vouchers/create",
  "/admin/vouchers/:voucherId",
];

/** Returns the matched known route pattern for a pathname, or null if it doesn't match any (fails safe: caller should skip sending an event rather than send a raw pathname). */
export function matchKnownRoutePattern(pathname: string): string | null {
  for (const pattern of KNOWN_ROUTE_PATTERNS) {
    if (matchPath(pattern, pathname)) {
      return pattern;
    }
  }
  return null;
}
